import * as React from 'react';
import * as Yup from 'yup';

import * as Edge from '../../core';
import FormField from '../formField';

import './index.scss';

interface AcknowledgeSubscriptionFieldsProps {
	renewalMonths: number;
}

export interface AcknowledgeSubscriptionFieldValues {
	acknowledgeSubscription?: boolean;
	acknowledgeSubscriptionStart?: boolean;
	acknowledgeCancellation?: boolean;
	acknowledgeRefundPolicy?: boolean;
}

export const acknowledgeSubscriptionFieldValidations = {
	acknowledgeSubscription: Yup.boolean().oneOf([true], 'Acknowledgment of automatic renewal is required'),
	acknowledgeSubscriptionStart: Yup.boolean().oneOf([true], 'Acknowledgment of subscription terms is required'),
	acknowledgeCancellation: Yup.boolean().oneOf([true], 'Acknowledgment of cancellation process is required'),
	acknowledgeRefundPolicy: Yup.boolean().oneOf([true], 'Acknowledgment of refund policy is required'),
};

export const AcknowledgeSubscriptionFields = ({ renewalMonths }: AcknowledgeSubscriptionFieldsProps) => (
	<>
		<FormField
			description={`I understand that I am purchasing a recurring subscription that renews automatically every ${
				renewalMonths === 1 ? 'month' : 'year'
			} unless I cancel`}
			label={`I understand that I am purchasing a recurring subscription that renews automatically every ${
				renewalMonths === 1 ? 'month' : 'year'
			} unless I cancel`}
			name="acknowledgeSubscription"
			type="checkbox"
		/>
		<FormField
			description="I have read the Subscription Terms and understand that my subscription starts immediately upon placing my order"
			label={
				<>
					I have read the{' '}
					<a
						href={Edge.Constants.URL_SUBSCRIPTION_TERMS}
						target="_blank"
						rel="noopener noreferrer"
						className="subscription_terms_link"
					>
						Subscription Terms
					</a>{' '}
					and understand that my subscription starts immediately upon placing my order
				</>
			}
			name="acknowledgeSubscriptionStart"
			type="checkbox"
		/>
		<FormField
			description="I understand I can cancel anytime from the Manage Plan page, effective at the end of my billing period"
			label="I understand I can cancel anytime from the Manage Plan page, effective at the end of my billing period"
			name="acknowledgeCancellation"
			type="checkbox"
		/>
		<FormField
			description="I have read the Refund Policy and understand that no refunds are issued for partial months"
			label={
				<>
					I have read the{' '}
					<a
						href={Edge.Constants.URL_REFUND_POLICY}
						target="_blank"
						rel="noopener noreferrer"
						className="refund_policy_link"
					>
						Refund Policy
					</a>{' '}
					and understand that no refunds are issued for partial months
				</>
			}
			name="acknowledgeRefundPolicy"
			type="checkbox"
		/>
	</>
);
